module.exports = __webpack_public_path__ + "img/curling-stone.76bf5006.svg";